export enum AlarmOriginEntityEnum {
  GATEWAY = "GATEWAY",
  DEVICE = "DEVICE",
  METRIC = "METRIC"
}
